export default [
  {
    icon: 'mdi-eye',
    title: 'Lihat Nilai Keterampilan',
    event: 'onViewNilaiKeterampilan',
    akses: true,
  },
  {
    icon: 'mdi-eye',
    title: 'Lihat Nilai Kehadiran',
    event: 'onViewNilaiKehadiran',
    akses: true,
  },
  {
    icon: 'mdi-pencil',
    title: 'Nilai Keterampilan',
    event: 'onNilaiKeterampilan',
    akses: 'psp-pelatihan-imbas-nilai.save',
  },
  {
    icon: 'mdi-pencil',
    title: 'Nilai Kehadiran',
    event: 'onNilaiKehadiran',
    akses: 'psp-pelatihan-imbas-nilai.save',
  },
];
